const data = [
  {
    id: 1,
    image: "https://img.icons8.com/ios/100/000000/web.png",
    title: "Front-end Development",
    desc: "I like to code things from scratch, and enjoy bringing ideas on frontend development.",
    // tools: "html, css, bootstrap, tailwind, github, react, npm, javascript, terminal, google fonts, chrome dev tools, vscode, figma, adobe illustrator etc"
  },
  {
    id: 2,
    image: "https://img.icons8.com/external-flatart-icons-outline-flatarticons/100/000000/external-designing-graphic-designer-flatart-icons-outline-flatarticons.png",
    title: "Design And Development",
    desc: "I like to keep the content simple in structure, clear in code, put useful comments, modern design, performance optimized",
  },
  {
    id: 3,
    image: "https://img.icons8.com/external-nawicon-detailed-outline-nawicon/100/000000/external-responsive-seo-and-marketing-nawicon-detailed-outline-nawicon.png",
    title: "Responsive Design",
    desc: "I do make responsive design which enables the website accessible to all the users with any kind of devices",
  },
  {
    id: 4,
    image: "https://img.icons8.com/pastel-glyph/100/000000/website-analytics--v2.png",
    title: "Website Analytics",
    desc: "Get insights the data who is browsing your site, how is your website behaving to users and optimize the website accordingly",
  },
  {
    id: 5,
    image: "https://img.icons8.com/external-vitaliy-gorbachev-lineal-vitaly-gorbachev/100/000000/external-research-online-learning-vitaliy-gorbachev-lineal-vitaly-gorbachev.png",
    title: "Research And Report",
    desc: "I have the ability to search for, locate, organise, extract, do research and to write report, use online information that is relevant to a particular topic.",
  }
]
export default data
